export default "__VITE_PUBLIC_ASSET__8d7bdc56__"